import { useContext } from 'react'
import { GroupSearchContext } from '../contexts'

/**
 * @return {{
 *     adjustQueryParams: function,
 *     groupSearchChineseConversions: {},
 *     groupSearchCriteriaErrors: {},
 *     groupSearchQueryError: Error | null,
 *     groupSearchQueryLoading: boolean,
 *     groupSearchQueryParams: {},
 *     groupSearchQueryResults: {},
 *     resetGroupSearchQueryParams: function,
 *     updateGroupSearchQueryParams: function,
 *     setGroupSearchQueryParams: function,
 *   }}
 */
export default function useGroupSearch() {
  return useContext(GroupSearchContext)
}
